import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Button, Container, Grid, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import footer from '../assets/footer.webp';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubscribe = () => {
    if (!validateEmail(email)) {
      setError('Enter a valid email address');
      return;
    }
    setError('');
    setSubscribed(true);
    setEmail('');
    setTimeout(() => setSubscribed(false), 2500);
  };

  const linkStyle = {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    marginBottom: '8px',
    fontFamily: 'Nunito',
  };

  return (
    <Box
      sx={{
        color: '#fff',
        pt: 6,
        pb: 3,
        backgroundImage: `url(${footer})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          width: {
            xs: '95%',
            sm: '100%',
            md: '100%',
            lg: '85%',
            xl: '85%',
          },
          fontFamily: 'Nunito, sans-serif',
        }}
        maxWidth="lg"
      >
        <Container maxWidth="lg">

          <Grid container spacing={4} sx={{ color: '#fff', display: 'flex', justifyContent: 'space-between' }}>
            <Grid item xs={12} md={3}>
              <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%" width={300}>
                <img
                  src="https://loopsystech.in/static/media/Loopsys%20logo%20without%20background.fca3c85ea19b7855f32d.png"
                  alt="Company Logo"
                  style={{ width: 150 }}
                />
                <Typography variant="body2" color="inherit" sx={{ fontFamily: 'Nunito, sans-serif', mt: 1 }}>
                  At Loopsys Technology, we believe great ideas deserve great execution.
                  Our team crafts custom digital experiences that are user-centric and future-ready.
                  We’re more than a service provider — we’re your tech growth partner.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={8}>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h3" gutterBottom sx={{ fontWeight: '600', fontSize: '26px', fontFamily: 'Rajdhani' }}>
                    Company
                  </Typography>
                  {[
                    ['About Us', '/about-us'],
                    ['Our Projects', '/projects'],
                    ['Careers', '/careers'],
                    ['Terms and Condition', '/terms'],
                    ['Policies', '/policies'],
                  ].map(([label, to]) => (
                    <RouterLink key={label} to={to} style={linkStyle}>
                      <ChevronRightIcon sx={{ fontSize: 16, color: 'white', mr: 1 }} />
                      {label}
                    </RouterLink>
                  ))}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h3" gutterBottom sx={{ fontWeight: '600', fontSize: '26px', fontFamily: 'Rajdhani' }}>
                    Our Services
                  </Typography>
                  <RouterLink to="/projects" style={linkStyle}>
                    <ChevronRightIcon sx={{ fontSize: 16, color: 'white', mr: 1 }} />
                    Our Work
                  </RouterLink>
                  <RouterLink to="/services" style={linkStyle}>
                    <ChevronRightIcon sx={{ fontSize: 16, color: 'white', mr: 1 }} />
                    IT Solutions
                  </RouterLink>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h3" gutterBottom sx={{ fontWeight: '600', fontSize: '26px', fontFamily: 'Rajdhani' }}>
                    Newsletter
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily: 'Nunito', mb: 2, fontSize: '16px' }}>
                    Subscribe our Newsletter
                  </Typography>
                  <TextField
                    type="email"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    variant="outlined"
                    fullWidth
                    sx={{
                      mb: 2,
                      '& .MuiOutlinedInput-root': {
                        color: 'white',
                        backgroundColor: 'transparent',
                        height: '36px',
                        '& fieldset': { borderColor: 'white' },
                        '&:hover fieldset': { borderColor: '#ccc' },
                        '&.Mui-focused fieldset': { borderColor: '#0c5ACD' },
                      },
                      '& .MuiInputBase-input::placeholder': {
                        color: 'white',
                        opacity: 0.7,
                      },
                    }}
                    error={!!error}
                    helperText={error}
                  />
                  <Button
                    onClick={handleSubscribe}
                    sx={{
                      backgroundColor: '#0c5ACD',
                      color: 'white',
                      textTransform: 'uppercase',
                      fontWeight: '600',
                      fontFamily: 'Rajdhani',
                      px: 3,
                      '&:hover': {
                        backgroundColor: 'white',
                        color: '#0c5ACD',
                      },
                    }}
                  >
                    Subscribe
                  </Button>
                  {subscribed && (
                    <Typography variant="subtitle2" sx={{ mt: 1.5, color: 'lightgreen', fontFamily: 'Nunito' }}>
                      Subscribed
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Box
            mt={4}
            borderTop={1}
            borderColor="#333"
            pt={2}
            display="flex"
            justifyContent="space-between"
            flexDirection={{ xs: 'column', sm: 'row' }}
            alignItems="center"
          >
            <Typography variant="body2" color="inherit" sx={{ fontFamily: 'Nunito, sans-serif' }}>
              © 2025 Loopsys Technologies. All rights reserved.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
